import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { FennScreen } from "./FennLoader";
import NameAccount from "./auth/NameAccount";
import { loadAccountName } from "../auth/accountName";

export default function ProtectedRoute({ children }) {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // A recovery session that still has to create its passkey is signed in but
  // may do nothing else: it belongs on /recover, not /login.
  const [mustFinishRecovery, setMustFinishRecovery] = useState(false);
  // An account without a name is asked for one before the Studio opens (PLAN.md).
  const [needsName, setNeedsName] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // ✅ انتظر 300ms للتأكد من أن localStorage مكتمل في الموبايل
        await new Promise((resolve) => setTimeout(resolve, 300));

        const token = localStorage.getItem("token");
        if (!token) {
          setIsAuthenticated(false);
          return;
        }

        // Relative, like every other call in the app. This was hardcoded to
        // https://studio.fennira.com, so a local or staging build authenticated
        // against PRODUCTION — which also meant the dev proxy added in
        // package.json couldn't route it.
        const res = await axios.get(
          "/api/check-auth",
          {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 10000, // مهم للموبايل
          }
        );

        setIsAuthenticated(res.data.authenticated);
        if (res.data.authenticated) {
          // If this check fails, the Studio opens anyway: a name must never lock someone out.
          try { setNeedsName((await loadAccountName()).needsName); } catch { /* ask next time */ }
        }
      } catch (err) {
        if (err?.response?.data?.code === "passkey_required") setMustFinishRecovery(true);
        setIsAuthenticated(false);
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  // Same animated logo, same place, as the page-load splash it replaces.
  if (!authChecked) return <FennScreen label="Checking your sign-in" />;

  if (mustFinishRecovery) return <Navigate to="/recover" replace />;
  if (isAuthenticated && needsName) return <NameAccount onDone={() => setNeedsName(false)} />;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}
